console.log('[ZP Upsell] Script loaded');

(function () {
  function getSectionInnerHTML(html, selector) {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  function refreshMiniCart(parsedState) {
    var sections = [
      { id: 'mini-cart',               section: 'mini-cart',               selector: '.shopify-section' },
      { id: 'cart-icon-bubble',         section: 'cart-icon-bubble',         selector: '.shopify-section' },
      { id: 'mobile-cart-icon-bubble',  section: 'mobile-cart-icon-bubble',  selector: '.shopify-section' }
    ];
    sections.forEach(function (s) {
      var el = document.getElementById(s.id);
      if (!el || !parsedState.sections || !parsedState.sections[s.section]) return;
      var target = el.querySelector(s.selector) || el;
      target.innerHTML = getSectionInnerHTML(parsedState.sections[s.section], s.selector);
    });
  }

  function initUpsellButtons() {
    console.log('[ZP Upsell] initUpsellButtons called, found:', document.querySelectorAll('.zp-upsell-btn').length, 'buttons');
  }

  // Event delegation — survives any innerHTML replacement of the cart drawer.
  // Registered once on DOMContentLoaded; works regardless of when buttons appear.
  if (!window.__zpUpsellDelegated) {
    window.__zpUpsellDelegated = true;
    console.log('[ZP Upsell] Registering delegated click listener');

    document.addEventListener('click', function (e) {
      var btn = e.target.closest('.zp-upsell-btn');
      if (!btn) return;

      var lineIndex = parseInt(btn.dataset.line, 10);
      var variantId = btn.dataset.variant;
      var handle = btn.dataset.handle;
      console.log('[ZP Upsell] Button clicked — line:', lineIndex, '| variant:', variantId, '| handle:', handle);
      btn.disabled = true;
      btn.textContent = 'Upgrading\u2026';

      fetch('/products/' + handle + '.js')
        .then(function (r) {
          console.log('[ZP Upsell] /products/' + handle + '.js status:', r.status, r.ok);
          return r.text();
        })
        .then(function (rawText) {
          console.log('[ZP Upsell] /products/ raw response (first 200 chars):', rawText.slice(0, 200));
          var product;
          try {
            product = JSON.parse(rawText);
          } catch (e) {
            throw new Error('Product fetch returned non-JSON (handle="' + handle + '"): ' + e.message);
          }
          return product;
        })
        .then(function (product) {
          var planId = null;
          if (product.selling_plan_groups && product.selling_plan_groups.length > 0) {
            var plans = product.selling_plan_groups[0].selling_plans;
            if (plans && plans.length > 0) planId = plans[0].id;
          }
          console.log('[ZP Upsell] Selling plan ID found:', planId, '| selling_plan_groups:', product.selling_plan_groups);
          if (!planId) {
            btn.disabled = false;
            btn.textContent = 'Upgrade and Save';
            alert('No subscription plan found for this product.');
            return;
          }
          return fetch('/cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
              line: lineIndex,
              selling_plan: planId,
              sections: ['mini-cart', 'cart-icon-bubble', 'mobile-cart-icon-bubble'],
              sections_url: window.location.pathname
            })
          });
        })
        .then(function (r) {
          if (!r) return;
          console.log('[ZP Upsell] /cart/change.js response status:', r.status, r.ok);
          if (!r.ok) throw new Error('Cart update failed: HTTP ' + r.status);
          return r.json();
        })
        .then(function (parsedState) {
          if (!parsedState) return;
          console.log('[ZP Upsell] /cart/change.js parsed response:', parsedState);
          console.log('[ZP Upsell] sections keys returned:', parsedState.sections ? Object.keys(parsedState.sections) : 'none');
          refreshMiniCart(parsedState);
        })
        .catch(function (err) {
          console.error('[ZP Upsell] ERROR:', err);
          btn.disabled = false;
          btn.textContent = 'Upgrade and Save';
        });
    });
  }

  // MutationObserver — logs when upsell buttons appear in the cart drawer
  if (window.MutationObserver && !window.__zpUpsellObserver) {
    window.__zpUpsellObserver = true;
    var observer = new MutationObserver(function () {
      var count = document.querySelectorAll('.zp-upsell-btn').length;
      if (count > 0) {
        console.log('[ZP Upsell] MutationObserver: detected', count, '.zp-upsell-btn buttons in DOM');
      }
    });
    var cartContainer = document.getElementById('mini-cart') || document.body;
    observer.observe(cartContainer, { childList: true, subtree: true });
    console.log('[ZP Upsell] MutationObserver watching:', cartContainer.id || 'body');
  }

  initUpsellButtons();

  // Supplement Facts modal (Zengility)
  document.addEventListener('click', function(e) {
    if (e.target.matches('.zp-supfacts-btn')) {
      document.getElementById('zpSupFactsOverlay').classList.add('active');
    }
    if (e.target.matches('.zp-supfacts-close') || e.target.matches('.zp-supfacts-overlay')) {
      document.getElementById('zpSupFactsOverlay').classList.remove('active');
    }
  });
})();
